import styled from "styled-components/macro";


export const Container = styled.div`
  box-sizing: border-box;
  max-width: 1024px;
  margin: 0 auto;
  padding: 0 16px;
  flex: 1;
  width: 100%;
  padding-bottom: ${(props) =>
    props.payNowHeight ? `${props.payNowHeight}px` : 0};
  z-index: 1;
`;